module.exports = __webpack_public_path__ + "static/media/insights_cover.073fb513.jpg";